// Basic imports
import { createApp } from "vue";
import { createPinia } from "pinia";
import TheApp from "@/App.vue";
import { router } from "@/router/router";

// Plugins
import "@/plugins/dayjs";
import { plugins } from "@/plugins";

import "@/scss/properties.scss";
import "@/scss/general/general.scss";

// 3rd party logins
import vue3GoogleLogin from "vue3-google-login";

// HTML <head> tag
import { createHead } from "@unhead/vue/client";

const app = createApp(TheApp);
app.use(createPinia());
app.use(createHead());
app.use(vue3GoogleLogin, { clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID });
app.use(router);

plugins.forEach((plugin) => plugin.install(app));

app.mount("#app");
